module.exports = (RESTService) ->
  'ngInject'
  RESTService
    .withConfig(
      (r) ->
        r.setDefaultHttpFields(cache: true))
    .setFullResponse(true)
    .one('admin/country_codes')
